import List from 'ln/list/List';
import SequenceBase from './SequenceBase';
import UserFileModel from './UserFileModel';
import { ISlide } from '../slideview/SlideDetailView';
import { backend } from '../../setup';

class SlrgUserSequenceModel extends SequenceBase {

	static getInstance( origin ){
		return new SlrgUserSequenceModel({
			origin: origin,
			userfiles: new List<UserFileModel>(),
			modelName:"App\\SlrgUserSequence",
		});
	}

	constructor( json:Object ){
		super( json );	
	}

	get objective():string {
		return this.get<string>( 'objective' );	
	}
	
	get expertise():string {
		return this.get<string>( 'expertise' );	
	}

	get method_location():string {
		return this.get<string>( 'method_location' );	
	}

	get socialform():string {
		return this.get<string>( 'socialform' );	
	}

	get content():string {
		return this.get<string>( 'content' );	
	}
	
	get note():string {
		return this.get<string>( 'note', '' );
	}
	
	set note( note:string ){
		this.set( 'note', note );	
	}

	get userfiles():List<UserFileModel>{
		return this.get<List<UserFileModel>>( 'userfiles' );
	}

	set userfiles( userfiles:List<UserFileModel> ){
		this.set( 'userfiles', userfiles );
	}

	get slides():List<ISlide>{
		return this.get<List<ISlide>>( 'slides' );
	}

	set slides( slides:List<ISlide> ){
		this.set( 'slides', slides );
	}
	
}

export default SlrgUserSequenceModel;


backend.mapper.toModel.add( 'App\\SlrgUserSequence', function( json:any ) {
	
	var sequence = new SlrgUserSequenceModel( json );
	
	sequence.userfiles = new List<UserFileModel>( json.userfiles );

	return sequence;	
});

backend.mapper.toModel.alias( 'App\\SlrgUserSequencePreview', 'App\\SlrgUserSequence' );

backend.mapper.toJson.add( 'App\\SlrgUserSequence', function( model:SlrgUserSequenceModel){
	var clone = model.object();
	clone['userfiles'] = model.userfiles ? backend.mapper.json( model.userfiles.all() ) : [];
	return clone;
});

